import React, { useEffect, useRef } from 'react';
import cx from 'classnames';

import styles from './index.less';

export const TypeEnum = {
  SUCCESS: 0,
  FAIL: 1,
  INFO: 2
};

const BaseToast = ({ type = TypeEnum.SUCCESS, text }) => {
  const iconTypeClassName = {
    [TypeEnum.SUCCESS]: styles.success,
    [TypeEnum.FAIL]: styles.fail,
    [TypeEnum.INFO]: styles.info
  };

  const toastRootRef = useRef(null);

  useEffect(() => {
    const toastRootElem = toastRootRef.current;
    if (toastRootElem) {
      console.log(toastRootElem.offsetHeight);
    }
  }, []);

  return (
    <div className={styles.toastRoot} ref={toastRootRef}>
      <div className={styles.ToastBg}>
        <div className={styles.bgLeft}>
          {/* 根据图片的长度截取百分比，而不是父元素 */}
          <div data-name="" className={styles.main}>
            <img alt="" src={require('./images/toast-bg.png')} />
          </div>
          {/* 用于根据图片撑开元素 */}
          <img data-name="" alt="" src={require('./images/toast-bg.png')} />
        </div>
        <div className={styles.bgRight}>
          {/* 根据图片的长度截取百分比，而不是父元素 */}
          <div data-name="" className={styles.main}>
            <img alt="" src={require('./images/toast-bg.png')} />
          </div>
          {/* 用于根据图片撑开元素 */}
          <img data-name="" alt="" src={require('./images/toast-bg.png')} />
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.text}>{text}</div>
        <div className={styles.line} />
        <div className={cx(styles.icon, iconTypeClassName[type])} />
      </div>
    </div>
  );
};

export default BaseToast;
